export enum TransferEvent {
    Initiated = "Transfer_Initiated",
    StatusUpdate = "Transfer_StatusUpdate",
    QrCodeFetch = "Transfer_QrCodeFetch",
    QrCodeFetchFailed = "Transfer_QrCodeFetchFailed",
    RenderingQrCode = "Transfer_RenderingQrCode",
    CollectFailed = "Transfer_CollectFailed"
}